/**
 * Whether the signed-in viewer may see simulated (mock) robots (twin
 * slice 1, plan W3 steps 10, 11 and 14; contract §5).
 *
 * Reads the auth CONTEXT rather than `useAuth()`, which throws when no
 * provider is mounted. With no provider there are no roles, and no roles
 * reads as a site audience (`audienceFor`): the simulated fleet stays
 * hidden. That is the safe way to fail -- a hotel screen that wrongly
 * shows the mock robot is the mistake this exists to prevent.
 */
import { useContext } from 'react';
import { AuthContext } from './AuthContext';
import { canSeeSimulated } from './roles';

export function useCanSeeSimulated(): boolean {
  const auth = useContext(AuthContext);
  return canSeeSimulated(auth?.roles);
}
